import React from 'react';

import component, {classnames} from '../component';
import TopBanner from '../TopBanner';
import Link from '../Link';
import {HBox, VBox} from '../Box';
import {ArrowRight} from '../icons';


export default component('Error', function({code}) {
  return (
    <div className="Error">
      <div className="Error--Background" style={{
        backgroundImage: `url(${require('../../img/blood-bg.png')})`
      }}></div>
      <TopBanner />
      <div className="Error--Wrap">
        <HBox isContainer={true} width={1}></HBox>
        <HBox isContainer={true} width={2}>
          <div>
            <div className="Error-Title">Ошибка {code}</div>
            <div className="Error-Caption">Неправильно набран адрес, или такой страницы  на сайте больше не существует. Или ее кто-то подстрелил.</div>
            <ul className="Error-Links">
              <li>
                <Link name='home' className='Error-Link'>
                  Главная страница <ArrowRight className="Error-LinkArrow" />
                </Link>
              </li>
              <li>
                <Link name='sitemap' className='Error-Link'>
                  Карта сайта <ArrowRight className="Error-LinkArrow" />
                </Link>
              </li>
            </ul>
          </div>
        </HBox>
        <HBox isContainer={true} width={1}></HBox>
      </div>
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/pages/Error.js